import React, { Component } from 'react'
import GoogleMapReact from "google-map-react";

const AnyReactComponent = ({ text }) => <div>{text}</div>;
const Marker = () => <div style={{position: 'absolute',
transform: 'translate(-50%, -100%)'}} ><img src={'imgs/marker.png'} width="30px"/></div>;

class Mapa extends Component {
    constructor(props){
        super(props);
        this.state = {
          coords: { lat: -34.6162054, lng: -58.4942367 },
          zoom: 16
        };
    }


    componentDidMount(){
        //this.googleChecker();
    }

    render() {
        return (
        <div style={{ width: 250, height: 150 }}  >
            <GoogleMapReact
                bootstrapURLKeys={{ key: 'AIzaSyBgiL1v3YHQYU6I8v_UHdQyJZbt0dVVKD4' }}
                defaultCenter={this.state.coords}
                defaultZoom={this.state.zoom}>
                <Marker lat={this.state.coords.lat} lng={this.state.coords.lng} />
            </GoogleMapReact>
        </div>
        );
    }
}

export default Mapa


// WEBPACK FOOTER //
// ./src/containers/mapa.js